import { config } from "../../config/constants"

const Footer = () => {
  return (
    <footer className="wk-footer wk-footer-workflow" role="contentinfo">
      <div
        className="wk-footer-container wk-footer-container-workflow"
        role="navigation"
      >
        <ul className="wk-footer-navigation wk-footer-navigation-workflow">
          {/*<li className="wk-footer-item">
            <a className="wk-footer-link" href="preventDefault()">
              Disclaimer
            </a>
          </li>
          <li className="wk-footer-item">
            <a className="wk-footer-link" href="preventDefault()">
              Privacy statement
            </a>
          </li>
          <li className="wk-footer-item">
            <a className="wk-footer-link" href="preventDefault()">
              Terms & conditions
            </a>
          </li>*/}
          <li className="wk-footer-item">
            <ul className="wk-footer-item-social wk-footer-item-social-workflow">
              <li className="wk-social-item">
                {" "}
              </li>
              <li className="wk-social-item">
                {""}
              </li>
            </ul>
          </li>
        </ul>
        <div className="wk-footer-copyright-info wk-footer-copyright-info-workflow">
          © {config.copyright} Wolters Kluwer. All rights reserved.
        </div>
        <ul className="wk-footer-navigation wk-footer-navigation-workflow">
          <li className="wk-footer-item">
            <ul className="wk-footer-item-social wk-footer-item-social-workflow">
              <li className="wk-social-item">
                {" "}
              </li>
              <li className="wk-social-item">
                {" "}
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </footer>
  )
}
export default Footer
